import { createGlobalStyle } from 'styled-components';

const FONT_PATH = process.env.PUBLIC_URL;

export default createGlobalStyle`

body {
  margin: 0;
}

@font-face {
  font-family: 'Avenir-Heavy';
  src: url('${FONT_PATH}/Avenir-Heavy.eot');
  src: url('${FONT_PATH}/Avenir-Heavy.eot?#iefix') format('embedded-opentype'),
    url('${FONT_PATH}/Avenir-Heavy.woff2') format('woff2'), url('${FONT_PATH}/Avenir-Heavy.woff') format('woff'),
    url('${FONT_PATH}/Avenir-Heavy.ttf') format('truetype'),
    url('${FONT_PATH}/Avenir-Heavy.svg#Avenir-Heavy') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Avenir-Medium';
  src: url('${FONT_PATH}/Avenir-Medium.eot');
  src: url('${FONT_PATH}/Avenir-Medium.eot?#iefix') format('embedded-opentype'),
    url('${FONT_PATH}/Avenir-Medium.woff2') format('woff2'), url('${FONT_PATH}/Avenir-Medium.woff') format('woff'),
    url('${FONT_PATH}/Avenir-Medium.ttf') format('truetype'),
    url('${FONT_PATH}/Avenir-Medium.svg#Avenir-Medium') format('svg');
  font-weight: normal;
  font-style: normal;
}
`;
